// eslint-disable-next-line import/extensions,import/no-unresolved
import './application';
import '../utils/bugsnag';
import '../utils/trail_autocomplete';
import '../apps/live_locator/main.ts';

console.log('initial load of live_locator.js')
